<ul class="dashletSiteacc__site-ul">
  @for (workspace of workspaceList; track workspace) {
    @if (!workspace.blocked) {
      <li
        class="dashletSiteacc__site"
      [ngClass]="{
        'dashletSiteacc__site--active': ppSiteRange.workspaceIds?.includes(workspace.workspaceId),
      }"
      (click)="
        updateSiteRange({
          accountId: ppAccount.accountId,
          workspaceIds: [workspace.workspaceId],
        })
      "
        >
        <h4 class="dashletSiteacc__site-circle">
          {{ ppWorkspaces[workspace.workspaceId]?.siteName | firstLetter }}
        </h4>
        <p class="dashletSiteacc__site-label">
          {{ ppWorkspaces[workspace.workspaceId]?.siteName }}
        </p>
      </li>
    }
    @if (workspace.blocked) {
      <li class="dashletSiteacc__site--disabled">
        <h4 class="dashletSiteacc__site-circle">
          {{ ppWorkspaces[workspace.workspaceId]?.siteName | firstLetter }}
        </h4>
        <p class="dashletSiteacc__site-label">
          {{ ppWorkspaces[workspace.workspaceId]?.siteName }}
        </p>
      </li>
    }
  }
</ul>
